import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import MenuCollapseItem from 'tm3-core/controls/menus/menu-collapse-item';

import GUID from 'bz-utilities/modules/variables/guid';

import { ConfigObservable } from 'bz-stores/lib/config';

import ReportsList from '../reports-list';

import featureFlag from 'tm3-core/stores/feature-store';

import { Divider } from '@material-ui/core';

interface IProps {
  clinicalStore?: any;
}

@inject('clinicalStore')
@observer
class MoreMenuItem extends React.Component<IProps> {
  render() {
    if (!this.show) {
      return null;
    }

    return (
      <React.Fragment>
        <Divider />
        <MenuCollapseItem primary={`Add ${this.name} Report`} MenuItemProps={{ dense: true }}>
          <ReportsList />
        </MenuCollapseItem>
      </React.Fragment>
    );
  }

  @computed
  get show() {
    const { details, referralStore } = this.props.clinicalStore.caseStore;
    const { closed, bookingAuditId } = details || {};

    if (!featureFlag.prontoIntegrationEnabled || !GUID.hasValue(bookingAuditId)) {
      return false;
    }
    const canReportToPronto = !!referralStore && referralStore.referral.canReport;
    return !closed && !!this.isAllowed && canReportToPronto;
  }

  @computed
  get isAllowed() {
    const { prontoStore } = this.props.clinicalStore;
    return !!Array.from(prontoStore.allowed.values()).find((x) => GUID.hasValue(x));
  }

  @computed
  get name() {
    return this.props.clinicalStore.prontoStore.name;
  }
}

export default MoreMenuItem;
